module.exports = __webpack_public_path__ + "static/media/desktop-tour-bg-dark.c74e93c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/desktop-tour-bg-dark.jpg
// module id = 577
// module chunks = 103